import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { LogoutIcon } from '@/assets/icons/LogoutIcon';
import { UserIcon } from '@/assets/icons/UserIcon';
import { useSignOut } from '@/core/auth/_hooks/useSignOut';
import { paths } from '@/core/router/paths';
import { Permission } from '@/core/store/auth/auth.types';
import { useHasPermission, useIdToken } from '@/core/store/auth/authSelectors';

import { LogoutButton } from '../LogoutButton/LogoutButton';

import { headerMenuStyles as sx } from './HeaderMenu.styles';

export const HeaderMenu = () => {
	const { t } = useTranslation();
	const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
	const idToken = useIdToken();
	const { handleSignOut } = useSignOut();
	const [open, setOpen] = useState(false);
	const dcrEnabled = useHasPermission(Permission.DcrEnabled);

	const handleClose = () => {
		setOpen(false);
	};

	const handleOpen = () => {
		setOpen(true);
	};

	const handleLogout = useCallback(async () => {
		await handleSignOut();
	}, [handleSignOut]);

	if (!idToken) {
		return null;
	}

	if (!dcrEnabled) {
		return <LogoutButton />;
	}

	return (
		<>
			<Box ref={setAnchorEl} sx={sx.menuButton}>
				<Avatar sx={sx.avatar} onClick={handleOpen}>
					<UserIcon sx={sx.avatarIcon} />
				</Avatar>
			</Box>

			<Menu
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'right'
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right'
				}}
				sx={sx.menu}
				disableAutoFocusItem
				disableScrollLock
				disablePortal
				slotProps={{
					list: {
						sx: sx.menuList
					}
				}}
			>
				<MenuItem component={Link} to={paths.dcrs}>
					{t('My DCRs')}
				</MenuItem>
				<MenuItem onClick={handleLogout}>
					<ListItemText>
						{t('Logout')}
						<LogoutIcon
							fill={'var(--mui-palette-text-secondary)'}
							sx={sx.logoutIcon}
						/>
					</ListItemText>
				</MenuItem>
			</Menu>
		</>
	);
};
